import React from "react";
import { JsIcon, JsIconBox } from "../../components/brand/JsIcon";
import { whyPoints, normChips } from "./data";

/**
 * WhySection — "Por qué Procure" + chips de normas verificadas.
 */
export function WhySection() {
  return (
    <section className="border-b border-gray-200 bg-white" data-testid="landing-why-section">
      <div className="container-prose py-20">
        <div className="max-w-2xl mb-12">
          <p className="text-xs uppercase tracking-[0.22em] text-brand-coral font-semibold mb-3">Por qué Procure</p>
          <h2 className="font-serif text-3xl sm:text-4xl text-gray-900 mb-3">
            Lista blanca normativa, revisión humana experta y trazabilidad legal.
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          {whyPoints.map(({ iconName, title, body }, idx) => (
            <div
              key={title}
              data-testid={`why-card-${idx}`}
              className="p-7 bg-brand-cream-soft border border-gray-200 rounded-sm hover:border-brand-burgundy hover:shadow-md transition-all"
            >
              <div className="mb-4">
                <JsIconBox name={iconName} size={44} boxSize={64} className="bg-white border border-brand-burgundy/15" />
              </div>
              <div className="text-[10px] uppercase tracking-widest text-brand-coral mb-2 font-semibold">{`0${idx + 1}`}</div>
              <h3 className="font-serif text-lg text-gray-900 mb-2">{title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>

        {/* Norm chips */}
        <div className="bg-brand-cream-soft border border-gray-200 rounded-sm p-6">
          <div className="flex items-center gap-2 mb-3">
            <JsIcon name="normas" size={20} />
            <p className="text-xs uppercase tracking-[0.22em] text-brand-coral font-semibold">
              Normas verificadas en lista blanca
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {normChips.map((n) => (
              <span
                key={n}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-brand-burgundy/20 text-brand-burgundy text-xs rounded-sm font-medium"
              >
                {n}
              </span>
            ))}
            <span className="inline-flex items-center px-3 py-1.5 bg-white border border-gray-300 text-gray-500 text-xs rounded-sm italic">
              + 28 normas adicionales
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
